<div class="k-loading-image" *ngIf="!resultItem?.displayBy"></div>

<section *ngIf="!!resultItem?.displayBy">
    <!--Filter Selection Dropdown List -->
    <section class="search-container">
        <kendo-dropdownlist [data]="displayBySelectionList"
                            [(ngModel)]="selectedDisplayBy"
                            textField="text"
                            valueField="sequence"
                            (ngModelChange)="onChangeDisplayBy($event)">
        </kendo-dropdownlist>
    </section>

    <!--TODO: Action Status UI -->
    <section>
      <div class="widget-table-box" *ngIf="!!displayResult">
        <div id="resp-table">
          <div id="resp-table-body">
            <div class="resp-table-row" *ngFor="let row of displayResult">
              <div class="table-body-title-cell"><b>{{row.key | xlat}}</b></div>
              <div class="table-body-title-cell" align="right"><b>{{row.value}}</b></div>
            </div>
          </div>
        </div>
      </div>
    </section>

</section>